import { useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { CheckCircle } from "lucide-react";

export default function RegisterSuccessPage() {
  const navigate = useNavigate();

  useEffect(() => {
    const registrationSuccess = sessionStorage.getItem("registration_success");
    if (registrationSuccess) {
      sessionStorage.removeItem("registration_success");
    }
  }, []);

  const handleGoToLogin = () => {
    navigate("/login");
  };

  return (
    <div className="min-h-screen flex items-center justify-center bg-gradient-to-br from-blue-50 to-indigo-100 p-4">
      <div className="bg-white rounded-2xl shadow-2xl p-8 max-w-md w-full text-center animate-fadeIn">
        <div className="flex justify-center mb-6">
          <div className="bg-green-100 rounded-full p-4">
            <CheckCircle className="w-16 h-16 text-green-600" />
          </div>
        </div>
        <h1 className="text-3xl font-bold text-gray-800 mb-4">
          Cadastro realizado com sucesso!
        </h1>
        <p className="text-gray-600 mb-8">
          Volte à tela inicial para realizar seu login.
        </p>
        <button
          onClick={handleGoToLogin}
          className="w-full bg-blue-600 text-white py-3 rounded-lg hover:bg-blue-700 transition-colors font-semibold text-lg"
        >
          OK
        </button>
      </div>
    </div>
  );
}
